// Cascading select editor: the parent list, then the chosen parent's
// children. Saves on ✓ (or Enter), leaves on ✕ (or Escape) — the child is
// a second pick, so a parent alone is not saved the moment it is chosen.
// Rules in ../utils/cascadingSelect.js.
import { useState } from 'react';
import { cascadingChildren, cascadingPick } from '../utils/cascadingSelect';

export default function CascadingSelectEditor({ options, value, onSave, onCancel, disabled = false }) {
  const [parentId, setParentId] = useState(value?.id != null ? String(value.id) : '');
  const [childId, setChildId] = useState(value?.child?.id != null ? String(value.child.id) : '');
  const children = cascadingChildren(options, parentId);

  const save = () => onSave(parentId ? cascadingPick(options, parentId, childId) : null);
  const onKeyDown = (e) => {
    if (e.key === 'Enter') { e.preventDefault(); save(); }
    if (e.key === 'Escape') { e.preventDefault(); onCancel(); }
  };

  return (
    <div className="screen-field-edit screen-field-edit-cascading" onKeyDown={onKeyDown}>
      <select
        className="screen-field-select"
        value={parentId}
        onChange={(e) => { setParentId(e.target.value); setChildId(''); }}
        disabled={disabled}
        aria-label="Option"
        autoFocus
      >
        <option value="">None</option>
        {(options || []).map((o) => (
          <option key={o.id} value={String(o.id)}>{o.value ?? o.name}</option>
        ))}
      </select>
      {children.length > 0 && (
        <select
          className="screen-field-select"
          value={childId}
          onChange={(e) => setChildId(e.target.value)}
          disabled={disabled}
          aria-label="Sub-option"
        >
          <option value="">None</option>
          {children.map((c) => (
            <option key={c.id} value={String(c.id)}>{c.value ?? c.name}</option>
          ))}
        </select>
      )}
      <div className="screen-field-edit-actions">
        <button type="button" className="screen-edit-btn save" onClick={save} disabled={disabled} title="Save">✓</button>
        <button type="button" className="screen-edit-btn cancel" onClick={onCancel} disabled={disabled} title="Cancel">✕</button>
      </div>
    </div>
  );
}
